import { CurrentUser, MenuResponse, OgData } from 'types';
import { AnswerItem } from './AnswerItem';
import { CustomerPageWrapper } from 'containers/CustomerPageWrapper';

import styles from './FAQ.module.scss';
import { getPageH1Title } from '../../utils/seoFormatters';

export type FaqAnswer = {
  answer: string;
  id: number;
  question: string;
  topic_id: number;
  topic_title: string;
};

export type FaqTopics = {
  id: number | string;
  title: string;
  answers: FaqAnswer[];
};

export type FaqPageProps = {
  faqTopics: FaqTopics[];
  menuData: MenuResponse;
  ogData?: OgData[];
  user?: CurrentUser;
};

export const FaqPage = ({ menuData, faqTopics = [], ogData, user }: FaqPageProps) => {
  return (
    <CustomerPageWrapper
      menuData={menuData}
      user={user}
      headTitle="FAQ Page | SENDY"
      ogData={ogData}
      hiddenComponentProps={{ title: getPageH1Title('faq') }}
    >
      <>
        <div className={styles.container}>
          <FaqContent faqTopics={faqTopics} />
        </div>
      </>
    </CustomerPageWrapper>
  );
};

export const FaqContent = ({ faqTopics }) => (
  <div className={styles.contentWrapper}>
    <div className={styles.content}>
      <h1>Frequently Asked Questions</h1>
    </div>
    {faqTopics.map((topic, index) => (
      <div key={index} className={styles.content}>
        <h2>{topic.title}</h2>
        {!!topic.answers?.length &&
        topic.answers.map((answer) => <AnswerItem key={`${answer.id}-${answer.topic_id}`} answer={answer} />)}
      </div>
    ))}
  </div>
)
